import DataServices from "@/core/DataServices";
import moment from "moment";
import {constants} from '../services/constants';
import Api from '../services/index';
import DataCommon from '../services/DataCommon';
var dataCommon = DataCommon.getConstans();

export default {
    async getSerialWarrantyActivationBySerial(serial_number) {
        serial_number = serial_number.toUpperCase();
        var modelName = 'request_activation_product_serial';
        var variables = {
            where_key: {product_serial_number: {serial_number: {_like: "%" + serial_number + "%"}}},
            limit: 1,
            orderBy: {
                id: 'desc',//lấy lần kích hoạt mới nhất
            }
        }
        var data = await DataServices.getList(modelName, {
            "variables": JSON.stringify(variables),
            'fields': 'request_activation_id serial_number_id warranty_status verify_status request_activation { created_date modified_date  customer_type customer_name date_of_sale customer_profile { full_name phone_number user_id  user { user_type } }  invoice_images acceptance_images }'
        });
        var list = data[Object.keys(data)];
        var dataRes = null;
        if (list != undefined && list != null && Object.keys(list).length > 0) {
            dataRes = {};
            var records = list[0];
            dataRes.request_activation_id = records.request_activation_id;
            if (records.request_activation != undefined && records.request_activation != null) {
                var userType = (records.request_activation.customer_profile != undefined && records.request_activation.customer_profile != null) ? records.request_activation.customer_profile.customer_type : 0;
                if (records.request_activation.customer_profile != undefined && records.request_activation.customer_profile != null) {
                    dataRes.user_id = records.request_activation.customer_profile.user_id;
                    dataRes.full_name = records.request_activation.customer_profile.full_name;
                    dataRes.phone_number_root = records.request_activation.customer_profile.phone_number;
                    dataRes.phone_number = dataRes.phone_number_root.replace('+84', '0');
                }

                if (records.request_activation.customer_name != undefined && records.request_activation.customer_name != null) {
                    dataRes.full_name = records.request_activation.customer_name;
                }

                if (records.request_activation.customer_type != undefined && records.request_activation.customer_type != null) {
                    userType = records.request_activation.customer_type;
                }
                dataRes.customer_type = userType;
                if (userType == 1) dataRes.group_customer = 'Cá nhân';
                else if (userType == 2) dataRes.group_customer = 'Doanh nghiệp';

                /*if(records.request_activation.invoice_images != null && records.request_activation.invoice_images != '') {
                    this.invoiceImagesTmp = records.request_activation.invoice_images;
                    var images = constants.isJSON(records.request_activation.invoice_images);
                    if (images != false) {
                        var json = JSON.parse(records.request_activation.invoice_images);
                        this.invoiceImages = json;
                    } else this.invoiceImages = images;
                }
                if (this.invoiceImages != null) {
                    for (let index = 0; index < this.invoiceImages.length; index++) {
                        var item = this.invoiceImages[index];
                        var path = item.url != undefined ? item.url : (item.cdn != null ? item.cdn + '' + item.path : item.path);
                        this.lstImages.push({src: path});
                    }
                }*/

                /*this.waittingActive = (records.warranty_status == 2) ? true : false;
                this.verify_status = records.verify_status;
                this.warranty_status_number = records.warranty_status;*/
                dataRes.warranty_status = records.warranty_status;
                dataRes.warranty_status_html = "";
                if (records.warranty_status == 2) dataRes.warranty_status_html = '<abbr style="padding: 2px 10px; border-radius: 5px; color:#fff; background: rgb(153, 0, 204);">Chờ kích hoạt</abbr>';
                else if (records.warranty_status == 0 || records.warranty_status == 5) dataRes.warranty_status_html = '<abbr style="padding: 2px 10px; border-radius: 5px; color:#fff; background: rgba(255, 102, 0, 1);">Chưa kích hoạt</abbr>';
                else if (records.warranty_status == 4) dataRes.warranty_status_html = '<abbr style="padding: 2px 10px; border-radius: 5px; color:#fff; background: rgb(51, 0, 204);">Hết bảo hành</abbr>';
                else if (records.warranty_status == 6) dataRes.warranty_status_html = '<abbr style="padding: 2px 10px; border-radius: 5px; color:#fff; background: rgb(0, 0, 0);">Sản phẩm huỷ</abbr>';
                else if (records.warranty_status == 3 || records.warranty_status == 1) dataRes.warranty_status_html = '<abbr style="padding: 2px 10px; border-radius: 5px; color:#fff; background: rgb(0, 204, 0);">Đã kích hoạt</abbr>';
            }
            //this.serial_number_id = records.serial_number_id;

            var data_info_serial = await this.getDataProductInfoWarrantyActivation(records.serial_number_id, records);
            dataRes.data_info_serial = data_info_serial;
        }else {
            dataRes = {};
            //Trường hợp sản phẩm chưa kích hoạt trả về để báo lỗi
            var where = {
                serial_number: {_like: "%"+serial_number+"%"}
            };
            var objSerial =await DataServices.getObjectData('product_serial_number',where,{id: 'desc'});
            if (!constants.isEmpty(objSerial)){
                dataRes.warranty_status = objSerial.warranty_status;
            }
        }
        //console.log("dataResdataRes:",dataRes)
        return dataRes;
    },
    async getDataProductInfoWarrantyActivation(serialID, records) {
        var name = 'product_serial_number_info';
        var variables = {
            where_key: {
                serial_number_id: {'_eq': serialID},
                status: {'_eq': 1}
            }
        }
        var data = await DataServices.getList(name, {
            "variables": JSON.stringify(variables),
            "fields": "serial_number_id product_id request_activation_id activation_date product_serial_number { modified_date created_date production_order_code_one { manufacturing_date } serial_number warranty_status production_status production_order_code product_id status product { warranty_time warranty_unit change_time change_unit returnable_time returnable_unit is_manually_verification}} customer_profile_id organization_id model_code name description thumbnail_id warranty_time warranty_unit is_returnable change_time change_unit returnable_time  returnable_unit last_modifier is_manually_verification created_date modified_date qr_code_size category_id date_of_sale activation_date status  warranty_status verify_status invoice_images acceptance_images data_dynamic_form categories { name } request_activation { customer_profile_id organization_id }"
        });
        var list = data[Object.keys(data)];
        var infoSerial = null;
        if (list != null && list.length) {
            infoSerial = {};
            var listData = list[0];
            infoSerial.listData = listData;
            infoSerial.serial_number = listData.product_serial_number.serial_number;
            infoSerial.activation_date_data = listData.activation_date;
            infoSerial.activation_date = listData.activation_date;
            infoSerial.returnable_time = (listData.returnable_time != undefined && listData.returnable_time != null) ? listData.returnable_time : 0;
            infoSerial.change_time = (listData.change_time != undefined && listData.change_time != null) ? listData.change_time : 0;
            infoSerial.change_time_data = (listData.change_time != undefined && listData.change_time != null) ? listData.change_time : 0;

            infoSerial.warranty_time = (listData.warranty_time != undefined && listData.warranty_time != null) ? listData.warranty_time : '';
            infoSerial.warranty_time_data = infoSerial.warranty_time;
            infoSerial.warranty_unit_data = listData.warranty_unit;
            var map_warranty_unit = dataCommon.COVERT_UNIT_MOMMENT[infoSerial.warranty_unit_data];
            infoSerial.warranty_activation_time = this.warranty_time;
            if (infoSerial.listData.activation_date != null && infoSerial.warranty_time != null && (listData.warranty_status == 3 || records.warranty_status == 4)) {
                //console.log("infoSerial.warranty_timeinfoSerial.warranty_time:",infoSerial.warranty_time)
                infoSerial.expired_activation_date = moment(infoSerial.listData.activation_date).add(infoSerial.warranty_time, map_warranty_unit);
                //infoSerial.expired_activation_date = moment(infoSerial.listData.activation_date).add(infoSerial.warranty_time, 'M');
                // this.expired_activation_date =  moment.utc(this.expired_activation_date).local().format('DD/MM/YYYY');
                infoSerial.expired_activation_date = moment.tz(infoSerial.expired_activation_date, constants.timeZone()).format('DD/MM/YYYY');
            //console.log("infoSerial.expired_activation_date:",infoSerial.expired_activation_date)
            }
            // this.activation_date =  moment.utc(this.activation_date).local().format('DD/MM/YYYY');
            console.log("records.warranty_status;",records.warranty_status)
            if (records.warranty_status == 3 || records.warranty_status == 4) {
                infoSerial.activation_date = moment.tz(infoSerial.activation_date, constants.timeZone()).format('DD/MM/YYYY');
            } else infoSerial.activation_date = '';

            if (records.request_activation.date_of_sale != null && records.warranty_status !== 0 && (records.warranty_status == 2 || records.warranty_status == 3 || records.warranty_status == 4)) {
                // this.date_of_sale =  moment.utc(listData.date_of_sale).local().format('DD/MM/YYYY');
                infoSerial.date_of_sale = moment.tz(records.request_activation.date_of_sale, constants.timeZone()).format('DD/MM/YYYY');
            }
            var date_production = (infoSerial.listData.product_serial_number != undefined && infoSerial.listData.product_serial_number != null && infoSerial.listData.product_serial_number.production_order_code_one != undefined && infoSerial.listData.product_serial_number.production_order_code_one != null) ? moment(infoSerial.listData.product_serial_number.production_order_code_one.manufacturing_date).format('DD/MM/YYYY') : '';
            if (!constants.isEmpty(date_production)){
                infoSerial.created_date = date_production;
            }else {
                if (listData.product_serial_number.modified_date != null) {
                    // this.created_date =  moment.utc(listData.product_serial_number.modified_date).local().format('DD/MM/YYYY');
                    infoSerial.created_date = moment.tz(records.request_activation.modified_date, constants.timeZone()).format('DD/MM/YYYY');
                } else if (records.request_activation.created_date != null) {
                    // this.created_date =  moment.utc(listData.product_serial_number.created_date).local().format('DD/MM/YYYY');
                    infoSerial.created_date = moment.tz(records.request_activation.created_date, constants.timeZone()).format('DD/MM/YYYY');
                }
            }

            infoSerial.model_code = listData.model_code;
            infoSerial.serial_number_id = serialID;
            // this.reason_warranty = listData.description;
            var dataSerial = await DataServices.getList('request_activation_product_serial', {
                "variables": JSON.stringify({
                    where_key: {
                        request_activation_id: {'_eq': this.request_activation_id},
                        status: {'_eq': 1},
                        serial_number_id: {'_eq': serialID}
                    }
                }), "fields": "verify_status warranty_status"
            });
            var listSerial = dataSerial[Object.keys(dataSerial)];
            if (listSerial != undefined && listSerial != null && Object.keys(listSerial).length > 0) {
                infoSerial.visibleWarranty = (listSerial[0].warranty_status == 3 || listSerial[0].warranty_status == 1 || listSerial[0].warranty_status == 4) ? true : false;
            }

           // var arrs = constants.returnDateCustomText(infoSerial.warranty_time, infoSerial.returnable_time, infoSerial.change_time, records.warranty_status, records.activation_date);
            var dataDateArr = {
                warranty_time:infoSerial.warranty_time,
                returnable_time:infoSerial.returnable_time,
                change_time:infoSerial.change_time,
                warranty_status:records.warranty_status,
                activation_date:infoSerial.listData.activation_date,
                arrWarrantyStatus:null,
                warranty_unit:infoSerial.warranty_unit_data
            }
            var arrs = constants.returnDateCustomText(dataDateArr);
            infoSerial.warranty_time = arrs.warranty_time_text;
            infoSerial.returnable_time = arrs.returnable_time_text;
            infoSerial.change_time = arrs.change_time_text;
        }
        return infoSerial;
    },
    async getAllProvince(whereAttach = null) {
        var where_key = {
            status: {'_in': [1]}
        };
        if (whereAttach){
            for (const [key, value] of Object.entries(whereAttach)) {
                where_key[key] = value;
            }
        }
        var variables = {
            where_key: where_key,
            orderBy: {
                ordering: 'desc',
                name: 'asc',
                modified_date: 'desc'
            }
        }
        var data = await DataServices.getList('view_province', {
            "variables": JSON.stringify(variables),
            "fields": "id,name"
        });
        var list = data[Object.keys(data)];
        return list;
    },
    async getDistrictByIdProvince(provinceID,whereAttach = null) {
        var where_key = {
            province_id: {'_eq': provinceID},
            status: {'_in': [1]}
        };
        if (whereAttach){
            for (const [key, value] of Object.entries(whereAttach)) {
                where_key[key] = value;
            }
        }
        var variables = {
            where_key:where_key,
            orderBy: {
                ordering: 'desc',
                name: 'asc',
                modified_date: 'desc'
            }
        }
        var data = await DataServices.getList('view_district', {
            "variables": JSON.stringify(variables),
            "fields": "id,name"
        });
        var list = data[Object.keys(data)];
        return list;
    },
    async getWardByIdDistrict(districtID,whereAttach = null) {
        var where_key = {
            district_id: {'_eq': districtID},
            status: {'_in': [1]}
        };
        if (whereAttach){
            for (const [key, value] of Object.entries(whereAttach)) {
                where_key[key] = value;
            }
        }
        var variables = {
            where_key: where_key,
            orderBy: {
                ordering: 'desc',
                name: 'asc',
                modified_date: 'desc'
            }
        }
        var data = await DataServices.getList('view_ward', {"variables": JSON.stringify(variables), "fields": "id,name"});
        var list = data[Object.keys(data)];
        return list;
    },
    async uploadOneImages(file) {
        // var vm = this;
        var returnData = '';
        let formData = new FormData();
        formData.append('file', file);
        await Api.post('/common/upload-s3', formData)
            .then((response) => {
                var obj = response.data.data;
                obj.path = obj.url;
                // vm.acceptance_images.push(obj);
                // vm.acceptance_images_string.push(response.data.data.url);
                returnData = obj;
            })
            .catch((err) => {
                returnData = JSON.stringify(err)
            });
        return returnData;
    },
    async get_warranty_repair_type_service_all() {
        var whereKey = {
            status: {'_in': [1]}
        }
        var variables = {
            where_key: whereKey,
            orderBy: {
                code: 'asc',
            }
        }
        var data = await DataServices.getList('warranty_repair_type_service', {"variables": JSON.stringify(variables)});
        var list = data[Object.keys(data)];
        return (list) ? list : [];
    },
    async get_type_failure_cause_all() {
        var whereKey = {
            status: {'_in': [1]}
        }
        var variables = {
            where_key: whereKey,
            orderBy: {
                code: 'asc',
            }
        }
        var data = await DataServices.getList('type_failure_cause', {"variables": JSON.stringify(variables)});
        var list = data[Object.keys(data)];
        return (list) ? list : [];
    },
    async get_service_park_all(where,order_by=null) {
        var variables = {
            where_key: where,
        }
        if (!constants.isEmpty(order_by)){
            variables.orderBy = order_by;
        }else {
            variables.orderBy =  {
                id: 'desc',
            };
        }
        var data = await DataServices.getList('service_park', {"variables": JSON.stringify(variables)});
        var list = data[Object.keys(data)];
        return (list) ? list : [];
    },
    async get_service_supplies_by_id_service_park(whereAttach=null) {

        var whereKey =  {
            status: {'_in': [1]},
          //  service_pack_id: {_eq: service_pack_id}
        }
        if (whereAttach){
            for (const [key, value] of Object.entries(whereAttach)) {
                whereKey[key] = value;
            }
        }

        var variables = {
            where_key: whereKey,
            orderBy: {
                id: 'desc',
            }
        }
        var data = await DataServices.getList('service_pack_service_supplies', {"variables": JSON.stringify(variables)});
        var list = data[Object.keys(data)];
        return (list) ? list : [];
    },
    async get_service_unit_all() {
        var variables = {
            where_key: {
                status: {'_in': [1]},
            },
            orderBy: {
                code: 'desc',
            }
        }
        var data = await DataServices.getList('service_unit', {"variables": JSON.stringify(variables)});
        var list = data[Object.keys(data)];
        return (list) ? list : [];
    },
    async get_user_by_organizatio_id(organizationID,whereAttach=null) {
        var whereKey = {
            status: {'_in': [1] },
            user_type: {'_gt': 1},
            // is_enabled: {'_eq': true},
            //id: {"_neq": this.$store.getters.fullname.id},
            full_name: {'_neq': ''}
        }
        if (whereAttach){
            for (const [key, value] of Object.entries(whereAttach)) {
                whereKey[key] = value;
            }
        }
        whereKey = Object.assign(whereKey,
            { "_and": {
                    "_or": [
                        {
                            organization_account: {
                                organization: {
                                    status: {"_eq": 1},
                                    id: {'_eq': organizationID}
                                }
                            }
                        },
                        {
                            organization_account: {
                                organization: {
                                    parent_id: {"_eq": organizationID},
                                    status: {"_eq": 1},
                                    organization_type: {"_eq": "affiliate"}
                                }
                            }
                        },
                        {
                            organization_account: {
                                organization: {
                                    parent_id: {"_eq": organizationID},
                                    status: {"_eq": 1},
                                    organization_type: {"_eq": "b2b"}
                                },
                                user: {
                                    is_representative: {"_eq": true}
                                }
                            }
                        }
                    ]
                }
            }
        );
        var variables = {
            where_key: whereKey,
            orderBy: {
                id: 'desc'
            }
        }

        var data = await DataServices.getList('users', {"variables": JSON.stringify(variables), "distinct": "id"});
        var list = data[Object.keys(data)];
        var map_check_name = {};
        if (list.length > 0){
            for (var i=0;i<list.length;i++){
                var fullname_check = list[i].full_name;
                //map_check_name[fullname_check] = 0;
                if (constants.isEmpty(map_check_name[fullname_check])){
                    map_check_name[fullname_check] = 0;
                }
                map_check_name[fullname_check] = map_check_name[fullname_check]+1;
                var str_space = " ";
                list[i].full_name =fullname_check+str_space.repeat(parseFloat(map_check_name[fullname_check]));
            }
        }

        //console.log("map_check_namemap_check_name:",map_check_name["Test Nguoi Dai Dien"]);
       // console.log("listlistlist:",list);
        return list;
    },
    async get_user_search_wr(whereAttach=null) {
        //Lấy tất cả khách hàng + nhân viên hong ky
        var whereKey = {
            status: {'_in': [1] },
            user_type: {'_gt': 0},
            // is_enabled: {'_eq': true},
            //id: {"_neq": this.$store.getters.fullname.id},
            full_name: {'_neq': ''}
        }
        if (whereAttach){
            for (const [key, value] of Object.entries(whereAttach)) {
                whereKey[key] = value;
            }
        }
        var variables = {
            where_key: whereKey,
            orderBy: {
                id: 'desc'
            }
        }

        var data = await DataServices.getList('users', {"variables": JSON.stringify(variables), "distinct": "id","fields": " id full_name user_type phone_number is_representative is_management_units is_enabled user_level { name } user_role { roles { name } } organization_account { organization { id name organization_parent { name } } }  obj_customer_profile { id full_name customer_type user_id phone_number birthday email address province { id name } district { id name } ward { id name }  } "});
        var list = data[Object.keys(data)];
        return list;
    },
    convertObjectDataSerial(param_convert){
        var checkSerialNumber = param_convert.objectDataSerial;
        var data_convert = {
            id:checkSerialNumber.data_info_serial.serial_number_id,
            mode:(!constants.isEmpty(param_convert.mode)) ? param_convert.mode:'add',
            type_service:(!constants.isEmpty(param_convert.type_service)) ? param_convert.type_service:null,
            maintenance_period:(!constants.isEmpty(param_convert.maintenance_period)) ? param_convert.maintenance_period:null,
            desc_status_product:(!constants.isEmpty(param_convert.desc_status_product)) ? param_convert.desc_status_product:'',
            list_img_status_product:(param_convert.list_img_status_product && param_convert.list_img_status_product.length>0) ? param_convert.list_img_status_product:[],
            object_info_product:{
                user_id:(checkSerialNumber.user_id) ? checkSerialNumber.user_id:'' ,
                full_name:(checkSerialNumber.full_name) ? checkSerialNumber.full_name:'' ,
                phone_number:(checkSerialNumber.phone_number) ? checkSerialNumber.phone_number:'',
                phone_number_root:(checkSerialNumber.phone_number_root) ? checkSerialNumber.phone_number_root:'',
                group_customer:(checkSerialNumber.group_customer) ? checkSerialNumber.group_customer:'',
                customer_type:(checkSerialNumber.customer_type) ? checkSerialNumber.customer_type:'',
                warranty_status_html:checkSerialNumber.warranty_status_html,
                model_code:(checkSerialNumber.data_info_serial) ? checkSerialNumber.data_info_serial.model_code:'',
                product_name:(checkSerialNumber.data_info_serial) ? checkSerialNumber.data_info_serial.listData.name:'',
                serial_number:(checkSerialNumber.data_info_serial) ? checkSerialNumber.data_info_serial.listData.product_serial_number.serial_number:'' ,
                categories_name:(checkSerialNumber.data_info_serial) ? checkSerialNumber.data_info_serial.listData.categories.name:'',
                warranty_time:checkSerialNumber.data_info_serial.warranty_time,
                change_time:checkSerialNumber.data_info_serial.change_time,
                returnable_time:checkSerialNumber.data_info_serial.returnable_time,
                created_date:(checkSerialNumber.data_info_serial) ? checkSerialNumber.data_info_serial.created_date:'',
                activation_date:(checkSerialNumber.data_info_serial) ? checkSerialNumber.data_info_serial.activation_date:'' ,
                expired_activation_date:(checkSerialNumber.data_info_serial) ? checkSerialNumber.data_info_serial.expired_activation_date:'',
            }
        };
        return data_convert;
    },
    async updateHistoryWarrantyRepairProductSn(content,list_wr_psn_id,process_status,modifier_id){
        var list_data_insert = [];
        if (list_wr_psn_id.length > 0){
            for (var i=0;i<list_wr_psn_id.length;i++){
                var object_data = {
                    warranty_repair_product_serial_number_id:list_wr_psn_id[i],
                    content:content,
                    process_status:process_status,
                    //type:type,
                    status:1,
                    modifier_id: modifier_id,
                    modified_date: constants.currentDate(),
                }
                list_data_insert.push(object_data);
            }
            await DataServices.insertData('warranty_repair_product_sn_history_update', {"variables": JSON.stringify({objects: list_data_insert})}).then(async () => {
            }).catch(async () => {
            });
            //update thời gian sản phẩm
            var paramsInfo = { modified_date: constants.currentDate()}
            var whereInfo = { id: {'_in': list_wr_psn_id} }
            await DataServices.updateData('warranty_repair_product_serial_number', {"variables": JSON.stringify({data_update: paramsInfo, where_key: whereInfo})});
        }
    },
    async updateStatusMaintence(process_status,list_id_mantence,creator_id,creator_organization_id){
            //update thời gian sản phẩm
            if (list_id_mantence.length > 0){
                var paramsInfo = { process_status: process_status};
                if (process_status == dataCommon.MAINTENANCE.PROCESS_STATUS.FOR_MAINTENANCE){
                    //Nếu trạng thái đã bảo trì thì thêm ngày bảo trì thực tế
                    paramsInfo.maintenance_done_date = constants.currentDate();
                }
                var whereInfo = { id: {'_in': list_id_mantence} }
                await DataServices.updateData('maintenance', {"variables": JSON.stringify({data_update: paramsInfo, where_key: whereInfo})});
                var list_data_insert = [];
                for (var i=0;i<list_id_mantence.length;i++){
                    var object_data = {
                        maintenance_period_id:list_id_mantence[i],
                        process_status:process_status,
                        creator_id:creator_id,
                        creator_organization_id: creator_organization_id,
                        created_date: constants.currentDate(),
                    }
                    list_data_insert.push(object_data);
                }
                if (list_data_insert.length > 0){
                    await DataServices.insertData('maintenance_process', {"variables": JSON.stringify({objects: list_data_insert})})
                }

            }

    },
    async get_organization_by_user_id(user_id){
        var where = {
            user_id:  {_eq: user_id}
        };
        var obj_organization =await DataServices.getObjectData('organization_account',where,{id: 'desc'});
        return obj_organization;
    },
    async getCustomerByIdProfile(id_customer_profile){
        var where = {
            id:  {_eq: id_customer_profile}
        };
        var obj_data =await DataServices.getObjectData('customer',where,{id: 'desc'});
        if (obj_data && Object.keys(obj_data).length === 0){
            var name_province = (!constants.isEmpty(obj_data.province)) ? obj_data.province.name:'';
            var name_district = (!constants.isEmpty(obj_data.district)) ? obj_data.district.name:'';
            var name_ward = (!constants.isEmpty(obj_data.ward)) ? obj_data.ward.name:'';
            var delivery_apartment_number = (!constants.isEmpty(obj_data.address)) ? obj_data.address.trim():'';

            if (
                !constants.isEmpty(name_province)
                && !constants.isEmpty(name_district)
                && !constants.isEmpty(name_ward)
                && !constants.isEmpty(delivery_apartment_number)
            ){
                obj_data.full_address = delivery_apartment_number+', '+name_ward+', '+name_district+', '+name_province;
            }
        }
        return obj_data;
    },
    async getRequestActivationById(request_activation_id){
        var name = 'request_activation';
        var variables = {
            where_key: {
                id: {'_eq': request_activation_id }
            },
            limit: 1
        }
        var data = await DataServices.getList(name, {"variables": JSON.stringify(variables), "fields": "id customer_name customer_type customer_profile { user_id customer_type full_name phone_number birthday email address province { id name } district { id name } ward { id name } }"});
        var list = data[Object.keys(data)];
        if (list !== undefined && list !== null && Object.keys(list).length) {
            var item = list[0];
            if (item){
                if (!constants.isEmpty(item.customer_profile)){
                    var name_province = (!constants.isEmpty(item.customer_profile.province)) ? item.customer_profile.province.name:'';
                    var name_district = (!constants.isEmpty(item.customer_profile.district)) ? item.customer_profile.district.name:'';
                    var name_ward = (!constants.isEmpty(item.customer_profile.ward)) ? item.customer_profile.ward.name:'';
                    var delivery_apartment_number = (!constants.isEmpty(item.customer_profile.address)) ? item.customer_profile.address.trim():'';

                    if (
                        !constants.isEmpty(name_province)
                        && !constants.isEmpty(name_district)
                        && !constants.isEmpty(name_ward)
                        && !constants.isEmpty(delivery_apartment_number)
                    ){
                        item.full_address = delivery_apartment_number+', '+name_ward+', '+name_district+', '+name_province;
                    }
                }
                return item;
            }
        }
        return null;
    },
    async get_maintence_by_serial_number_id(serial_number_id,process_status_display) {
        var whereKey = {
            serial_number_id: {_eq: serial_number_id},
            process_status: {_in: process_status_display}
        }
        var variables = {
            where_key: whereKey,
            orderBy: {
                parts_number: 'asc',
            }
        }
        var data = await DataServices.getList('maintenance', {"variables": JSON.stringify(variables)});
        var list = data[Object.keys(data)];
        return (list) ? list : [];
    },
    async callApiPost(url,params={},header={}) {
        var payloadDefault = {};
        var headerDefaul = {};
        if (!(Object.keys(params).length === 0)){
            for (const [key, value] of Object.entries(params)) {
                payloadDefault[key] = value;
            }
        }
        if (!(Object.keys(header).length === 0)){
            for (const [key_h, value_h] of Object.entries(header)) {
                headerDefaul[key_h] = value_h;
            }
        }
        headerDefaul["baseurlportal"] = window.origin;
        var config = {
            headers:headerDefaul
        }
        const results = await Api.post(url, payloadDefault,config);
        return results;
    },
    async callApiDownloadPost(url,params={},header={}) {
        var payloadDefault = {};
        if (!(Object.keys(params).length === 0)){
            for (const [key, value] of Object.entries(params)) {
                payloadDefault[key] = value;
            }
        }
        var headerDefaul = {};
        if (!(Object.keys(header).length === 0)){
            for (const [key_h, value_h] of Object.entries(header)) {
                headerDefaul[key_h] = value_h;
            }
        }
        var config = {
            responseType: 'blob',
            headers:headerDefaul
        }
        const results = await Api.post(url,payloadDefault,config)
        return results;
    },
    async getCodeNextWarrantyRepair() {
        var YY = moment.tz((new Date().toUTCString()), constants.timeZone()).format('YY');
        var codeLeft = "HK"+YY;
        var data = await DataServices.getObjectData('warranty_repair', {code: {_like: "%"+codeLeft+"%"} }, {id: 'desc'});
        if (!constants.isEmpty(data)) {
            var codeLast = data.code;
            var codeRightLast = codeLast.substring((codeLast.length - 6));//Cắt lấy 6 ký tự cuối cùng
            var codeRightTmp = (parseInt(codeRightLast) + 1).toString();
            return codeLeft + codeRightTmp.padStart(6, '0');
        }
        return codeLeft+'000001';
    },
    async sendPushNotification(group_type,list_object_id) {
         await this.callApiPost('/notification/function-send-notification-web',{group_type:group_type,list_object_id:list_object_id},{});
         return true;
    },
    async insertProcessWR(warranty_repair_id,process_status,creator_id,creator_organization_id){
        //var vm = this;
        /*var organization = this.$myConstants.organizationUserLogin();
        var creator_organization_id = (!this.$myConstants.isEmpty(organization.id)) ? organization.id:null;*/
        //thêm vào bảng lịch sử trạng thái
        var paramsProcess = {
            warranty_repair_id: warranty_repair_id,
            process_status: process_status,
            creator_organization_id: creator_organization_id,
            creator_id: creator_id,
            created_date: constants.currentDate(),
        }
        await DataServices.insertData('warranty_repair_process', {"variables": JSON.stringify({objects: paramsProcess})});
        return true;
    },
    async id_organization_hong_ky(){
        var whereKey = {
            key: {'_eq': 'ORGANIZATION_ROOT' }
        }
        var data = await DataServices.getObjectData('settings', whereKey, {id: 'desc'});
        if (data){
            return data.value;
        }
        return null;
    },
    async convertFilter(type_input,key,filters) {
        if (type_input == 'DateRange'){
            if (!constants.isEmpty(filters[key]) && !constants.isEmpty(filters[key][0])  && !constants.isEmpty(filters[key][1])) {
                return  {
                    type_input:'DateRange',
                    value:{
                        /*from : moment(filters[key][0]).format(),//.utc()
                        to : moment(filters[key][1]).add(24, 'hours').format(),//.utc()*/
                        from : moment.tz(moment(filters[key][0]).format("YYYY-MM-DD"), constants.timeZone()).format('YYYY-MM-DD HH:mm:ss'),//.utc() giờ db đang giờ vn nên filter giờ vn
                        to : moment.tz(moment(filters[key][1]).format("YYYY-MM-DD")+" 23:59:59", constants.timeZone()).format('YYYY-MM-DD HH:mm:ss'),//.utc() giờ db đang giờ vn nên filter giờ vn
                    },
                };
            }else {
                return  {
                    type_input:'DateRange',
                    value:null
                };
            }
        }else {
            return  {
                type_input:type_input,
                value:filters[key],
            };
        }
    },
    async list_all_organization() {
        var whereKey = {
            status: {'_in': [1] }
        }
        var variables_organization = {
            where_key: whereKey,
            orderBy: {"id": "desc"}
        }
        var list_organization = await DataServices.getListData('organization', {"variables": JSON.stringify(variables_organization)});
        return list_organization;
    },
    async list_all_category() {
        var whereKey = {
            status: {'_in': [1] }
        }
        var variables = {
            where_key: whereKey,
            orderBy: {"id": "desc"}
        }
        var list= await DataServices.getListData('categories', {"variables": JSON.stringify(variables)});
        return list;
    },
    async list_all_product() {
        var variables = {
            where_key: {
                status: {'_in': [1] },
                production_status: {'_eq': 1},
                categories: {
                    status: {'_eq': 1}
                }
            },
            orderBy: {
                name: 'asc',
                created_date: 'desc'
            }
        }
        var data = await DataServices.getList('product', {"variables": JSON.stringify(variables), "fields": 'id name model_code'});
        var list = data[Object.keys(data)];
        var list_product = [];
        if (list != null && Object.keys(list).length) {
            for (let index = 0; index < list.length; index++) {
                var pro = list[index];
                list_product.push({name: pro.model_code + ' - ' + pro.name, value: pro.id});
            }
        }
        return list_product;
    },
    async list_all_service_supplies() {
        var variables = {
            where_key: {
                status: {'_in': [1]},//0,
            },
            orderBy: {
                id: 'desc',
            }
        }
        var list_data = await DataServices.getListData('service_supplies', {"variables": JSON.stringify(variables)});
        if (list_data != null && Object.keys(list_data).length) {
            for (let index = 0; index < list_data.length; index++) {
                var code = (!constants.isEmpty(list_data[index].code)) ? list_data[index].code : '';
                var name = (!constants.isEmpty(list_data[index].name)) ? list_data[index].name : '';
                list_data[index].lable = code + ' - ' + name;
            }
        }else {
            list_data = [];
        }
        return list_data;
    },
    async id_setting_unit_ttbh(){//lấy id trung tâm bảo hành
        var whereKey = {
            key: {'_eq': 'SERVICE_CENTER' }
        }
        var data = await DataServices.getObjectData('settings', whereKey, {id: 'desc'});
        if (data){
            return data.value;
        }
        return null;
    },
    async updateCustomerDelete(user_id_delete,phone_old) {
        var random_code = Math.floor(Math.random() * 100) + '' + moment().format("YYMMDD");
        var phone_number_bk = phone_old + '_d' + random_code;
        var paramsInfoUser = {phone_number: phone_number_bk}
        var whereInfoUser = {id: {_eq: user_id_delete}}
        await DataServices.updateData('users', {
            "variables": JSON.stringify({
                data_update: paramsInfoUser,
                where_key: whereInfoUser
            })
        });

        var paramsInfoCustomer = {phone_number: phone_number_bk}
        var whereInfoCustomer = {user_id: {_eq: user_id_delete}}
        await DataServices.updateData('customer', {
            "variables": JSON.stringify({
                data_update: paramsInfoCustomer,
                where_key: whereInfoCustomer
            })
        });
        return true;
    }
    ,
    splitModelNameQrcode(model_name){
        //console.log("model_namemodel_name:",model_name)
        var modelCodeLast ="";
         var count_last=0;
        var modelCodeFirts="";
        if (model_name.indexOf("-") != -1){
            var  arrModelCode =model_name.split("-");
            if (arrModelCode.length > 0){
                for (var i=0;i<arrModelCode.length;i++){
                    if (i==0){
                        modelCodeFirts=arrModelCode[i];
                        if (arrModelCode.length >1){
                            modelCodeFirts +="-";
                        }
                    }else {
                        if (count_last!=0){
                            modelCodeLast +="-";
                        }
                        modelCodeLast +=arrModelCode[i];
                        count_last++;
                    }
                }
            }
        }else {
            var length =model_name.length;
            if (parseFloat(length) >10){
                var lengthFisrt=Math.ceil((length/2));//le lam tron len
                var  arrModelCode_1 =model_name.split("");
                if (arrModelCode_1.length > 0){
                    for (var h=0;h<arrModelCode_1.length;h++){
                        if (h<lengthFisrt){
                            modelCodeFirts +=arrModelCode_1[h];
                        }else {
                            modelCodeLast +=arrModelCode_1[h];
                        }
                    }
                }
            }else{
                modelCodeFirts =model_name;
            }
        }
        //var  arrModelCode =model_name.split("-");

        /*if (arrModelCode.length > 0){
            for (var i=0;i<arrModelCode.length;i++){
                if (i==0){
                    modelCodeFirts=arrModelCode[i];
                    if (arrModelCode.length >1){
                        modelCodeFirts +="-";
                    }
                }else {
                    if (count_last!=0){
                        modelCodeLast +="-";
                    }
                    modelCodeLast +=arrModelCode[i];
                    count_last++;
                }
            }
        }*/

        /*var length =model_name.length;
        if (parseFloat(length) >10){
            var lengthFisrt=Math.ceil((length/2));//le lam tron len
            var  arrModelCode =model_name.split("");
            if (arrModelCode.length > 0){
                for (var i=0;i<arrModelCode.length;i++){
                    if (i<lengthFisrt){
                        modelCodeFirts +=arrModelCode[i];
                    }else {
                        modelCodeLast +=arrModelCode[i];
                    }
                }
            }
        }else{
            modelCodeFirts =model_name;
        }*/
        return {
            modelCodeLast:modelCodeLast,
            modelCodeFirts:modelCodeFirts,
        };
    },

}
